var map = {
	"./bold-icon-white.svg": "2373",
	"./code-block-icon-white.svg": "e839",
	"./code-icon-white.svg": "c812",
	"./hr-icon-white.svg": "1c2d",
	"./img-icon-white.svg": "fc07",
	"./italic-icon-white.svg": "dd24",
	"./link-icon-white.svg": "5ac4",
	"./ol-icon-white.svg": "857e",
	"./paragraph-icon-white.svg": "4933",
	"./quote-icon-white.svg": "8174",
	"./redo-icon-white.svg": "5f55",
	"./strikethrough-icon-white.svg": "c664",
	"./table-addca-icon-white.svg": "d001",
	"./table-addcb-icon-white.svg": "dcb9",
	"./table-addra-icon-white.svg": "3841",
	"./table-addrb-icon-white.svg": "04b9",
	"./table-delc-icon-white.svg": "6607",
	"./table-delete-icon-white.svg": "9b76",
	"./table-delr-icon-white.svg": "ca7a",
	"./table-icon-white.svg": "d76a",
	"./table-merge-icon-white.svg": "3e00",
	"./ul-icon-white.svg": "564e",
	"./underline-icon-white.svg": "bff8",
	"./undo-icon-white.svg": "6763",
	"./video-icon-white.svg": "0f35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a07";